const constant = {
  JUDGE_TYPE: {
    NORMAL: 'normal',
    THIRD_PARTY: 'thirdParty',
  },
  SCORE_RULE: {
    CHINESE: 'chinese', // 中國規則、數子法
    JAPANESE: 'japanese', // 日本規則、比目法
  },
};

export default constant;
